import React from 'react'
import BriefIntroduction from '../components/BriefIntroduction'

const Home = () => {
  return (
    <div name='home' className='bg-[#080808] w-full h-screen'>
      {/* container */}
<BriefIntroduction />
      <hr />
    </div>
  )
}

export default Home
